// TH
function isEmptyCheck(str) {
  if (str) {
    if (str.trim() != "") {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
}
function maxLengthCheck(str, len) {
  if (str) {
    if (str.length < len) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
}
function minLengthCheck(str, len) {
  if (str) {
    if (str.length >= len) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
}
// empty data TextField
export let isEmptyTextField = [
  (v) => isEmptyCheck(v) || "* กรุณากรอกข้อมูล",
  (v) => maxLengthCheck(v, 99) || "* ข้อมูลมีความยาวมากเกินไป",
];
// empty data Dropdown
export let isEmptyDropdown = [
  (v) => !!v || "* กรุณาเลือกข้อมูล",
  // (v) => maxLengthCheck(v, 99) || "* ข้อมูลมีความยาวมากเกินไป",
];
// EN
// empty data TextField
export let isEmptyTextField_en = [
  (v) => isEmptyCheck(v) || "* Please fill in information",
  (v) => maxLengthCheck(v, 99) || "* Data is too long",
];
// empty data Dropdown
export let isEmptyDropdown_en = [
  (v) => !!v || "* Please select information.",
  // (v) => maxLengthCheck(v, 99) || "* Data is too long",
];

export let en_language = [
  (v) => !!v || "* กรุณากรอกข้อมูล",
  (v) => /^([a-zA-Z])+$/.test(v) || "* กรุณากรอกข้อมูลเป็นภาษาอังกฤษ",
  (v) => maxLengthCheck(v, 30) || "* ข้อมูลมีความยาวมากเกินไป",
];
export let en_language_short = [
  (v) => !!v || "* กรุณากรอกข้อมูล",
  (v) => /^([a-zA-Z])+$/.test(v) || "* กรุณากรอกข้อมูลเป็นภาษาอังกฤษ",
  (v) => maxLengthCheck(v, 20) || "* ข้อมูลมีความยาวมากเกินไป",
];
export let th_language = [
  (v) => !!v || "* กรุณากรอกข้อมูล",
  (v) => /^([ก-๏])+$/.test(v) || "* กรุณากรอกข้อมูลเป็นภาษาไทย",
  (v) => maxLengthCheck(v, 30) || "* ข้อมูลมีความยาวมากเกินไป",
];
export let th_language_short = [
  (v) => !!v || "* กรุณากรอกข้อมูล",
  (v) => /^([ก-๏])+$/.test(v) || "* กรุณากรอกข้อมูลเป็นภาษาไทย",
  (v) => maxLengthCheck(v, 20) || "* ข้อมูลมีความยาวมากเกินไป",
];
// =====================================================================
// Username
export let username = [
  (v) => isEmptyCheck(v) || "* กรุณากรอกชื่อผู้ใช้",
  (v) =>
    /^([A-Za-z0-9])+$/.test(v) ||
    "* กรุณาใส่ชื่อผู้ใช้งานเป็นภาษาอังกฤษหรือตัวเลข",
  (v) => minLengthCheck(v, 4) || "* ชื่อผู้ใช้ควรมีความยาวอย่างน้อย 4 ตัว",
  (v) => maxLengthCheck(v, 64) || "* ข้อมูลมีความยาวมากเกินไป",
];
// Password
export let password = [
  (v) => isEmptyCheck(v) || "* กรุณากรอกรหัสผ่าน",
  (v) =>
    /^([A-Za-z0-9])+$/.test(v) || "* กรุณาใส่รหัสผ่านเป็นภาษาอังกฤษหรือตัวเลข",
  (v) => minLengthCheck(v, 8) || "* รหัสผ่านควรมีความยาวอย่างน้อย 8 ตัว",
  (v) => maxLengthCheck(v, 64) || "* ข้อมูลมีความยาวมากเกินไป",
];
// TitleName
export let titleName = [(v) => isEmptyCheck(v) || "* กรุณาเลือกคำนำหน้าชื่อ"];
// Other TitleName
export let otherTitleName = [
  (v) => isEmptyCheck(v) || "กรุณากรอกคำนำหน้าชื่อ",
  (v) =>
    /^([a-zA-Zก-๏ .])+$/.test(v) ||
    "* กรุณากรอกข้อมูลเป็นอักษรภาษาไทยหรือภาษาอังกฤษเท่านั้น",
  (v) => !/ /.test(v) || "* ห้ามมีช่องว่าง",
  (v) => maxLengthCheck(v, 64) || "* ข้อมูลมีความยาวมากเกินไป",
];
//  Firstname
export let firstname = [
  (v) => isEmptyCheck(v) || "* กรุณากรอกชื่อ",
  (v) =>
    /^([a-zA-Zก-๏ ])+$/.test(v) ||
    "* กรุณากรอกข้อมูลเป็นอักษรภาษาไทยหรือภาษาอังกฤษเท่านั้น",
  (v) => minLengthCheck(v, 2) || "* กรุณากรอกชื่ออย่างน้อย 2 ตัวอักษร",
  (v) => maxLengthCheck(v, 64) || "* ข้อมูลมีความยาวมากเกินไป",
  (v) => /^\S+(\s\S+)*$/.test(v) || "* กรุณากรอกข้อมูลให้ถูกต้อง",
  (v) => !/ /.test(v) || "* ห้ามมีช่องว่างระหว่างชื่อ",
];
//  Lastname
export let lastname = [
  (v) => isEmptyCheck(v) || "* กรุณากรอกนามสกุล",
  (v) =>
    /^([a-zA-Zก-๏ ])+$/.test(v) ||
    "* กรุณากรอกข้อมูลเป็นอักษรภาษาไทยหรือภาษาอังกฤษเท่านั้น",
  (v) => minLengthCheck(v, 2) || "* กรุณากรอกนุลามสกอย่างน้อย 2 ตัวอักษร",
  (v) => maxLengthCheck(v, 64) || "* ข้อมูลมีความยาวมากเกินไป",
  (v) => /^\S+(\s\S+)*$/.test(v) || "* กรุณากรอกข้อมูลให้ถูกต้อง",
  (v) => !/ /.test(v) || "* ห้ามมีช่องว่างระหว่างนามสุกล",
];
// phone number
function checkPhoneNumber(tel) {
  for (let i = 0; i < tel.length; i++) {
    if (tel[0] == 0 && (tel[1] == 6 || tel[1] == 8 || tel[1] == 9)) {
      return true;
    } else {
      return false;
    }
  }
}
export let phoneNumberForm = [
  (v) => isEmptyCheck(v) || "* กรุณากรอกหมายเลขโทรศัพท์มือถือ",
  (v) => v.length <= 12 || "* กรุณากรอกหมายเลขโทรศัพท์มือถือ 10 หลัก",
  (v) => minLengthCheck(v, 12) || "* กรุณากรอกหมายเลขโทรศัพท์มือถือ 10 หลัก",
  (v) =>
    (v.length == 12 ? checkPhoneNumber(v) : true) ||
    "* กรุณากรอกหมายเลขโทรศัพท์มือถือให้ถูกต้อง",
];
// Email Form
export let email = [
  // old template
  // v => isEmptyCheck(v) || "* กรุณากรอกอีเมล",
  // v => !/([ก-๏ ])/.test(v) || "* กรุณากรอกอีเมลให้ถูกต้อง",
  // v => /.+@.+\.+/.test(v) || "* กรุณากรอกอีเมลให้ถูกต้อง",
  // v => /.+@.+\.+([A-Za-z])+$/.test(v) || "* กรุณากรอกอีเมลให้ถูกต้อง",
  // v => /.+@.+\.+/.test(v) || "* กรุณากรอกอีเมลให้ถูกต้อง",
  // v => /.+@.+\.+([A-Za-z])+$/.test(v) || "* กรุณากรอกอีเมลให้ถูกต้อง",
  // new template
  (v) => isEmptyCheck(v) || "* กรุณากรอกอีเมล",
  (v) =>
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      v
    ) || "* กรุณากรอกอีเมลให้ถูกต้อง",
  (v) => maxLengthCheck(v, 99) || "* ข้อมูลมีความยาวมากเกินไป",
];
export let email_en = [
  (v) => isEmptyCheck(v) || "* Please enter email.",
  (v) =>
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      v
    ) || "* Please enter the email correctly.",
  (v) => maxLengthCheck(v, 99) || "* Data is too long",
];
// Address text area
export let address = [
  (v) => isEmptyCheck(v) || "* กรุณากรอกที่อยู่",
  (v) => maxLengthCheck(v, 99) || "*ข้อมูลมีความยาวมากเกินไป",
  (v) => /^\S+(\s\S+)*$/.test(v) || "ข้อความต้องไม่เริ่มหรือสิ้นสุดด้วยค่าว่าง",
];
// CitizenID
function checkCitizenID(id_tmp) {
  var id = id_tmp.replace(/-/g, "");
  let i, sum;
  for (i = 0, sum = 0; i < 12; i++) {
    sum += parseInt(id.charAt(i)) * (13 - i);
  }
  let mod = sum % 11;
  let check = (11 - mod) % 10;
  if (check == parseInt(id.charAt(12))) {
    return true;
  } else {
    return false;
  }
}
export let citizenID = [
  (v) => isEmptyCheck(v) || "* กรุณากรอกเลขบัตรประจำตัวประชาชน13หลัก",
  (v) =>
    (v.length == 17 ? checkCitizenID(v) : false) ||
    "* กรุณากรอกเลขบัตรประชาชนให้ถูกต้อง",
];
// Passport ID
export let passportID = [
  (v) => isEmptyCheck(v) || "* กรุณากรอกเลขที่หนังสือเดินทาง",
];
